import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ArchivedPageBannerV2Status_content$key } from '../src/__generated__/ArchivedPageBannerV2Status_content.graphql.ts';

export const ArchivedPageBanner: LoadableType<{
	contentId: string;
	marginStyle?: 'none' | 'bottom' | 'top' | 'both';
	contentFragmentRef?: ArchivedPageBannerV2Status_content$key | null;
	onPageRestore?: () => void | Promise<void>;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivedPageBanner" */ '../src/ArchivedPageBannerV2.tsx'
			)
		).ArchivedPageBanner,
});
